import React from "react";

const VenueMain = () => {
  return <div>VenueMain</div>;
};

export default VenueMain;